import React, { Component } from "react"
import { OverlayTrigger, Popover, Spinner, Tooltip } from "react-bootstrap"
import EmployeeDataTypes from "../../../../Types/EmployeeTypes"
import "./UserAdminTopRightControls.css"

interface UserAdminTopRightControlsProps {
    employee: EmployeeDataTypes
    updateEmployee: Function
    toggleActivate: Function
    isDirty: boolean
    secureIsDirty: boolean
    loading: boolean
    countMissing: Function
    cantSaveReasons: string[]
}

class UserAdminTopRightControls extends Component<UserAdminTopRightControlsProps, {}> {

    render() {

        const required: any = this.props.cantSaveReasons

        const CheckFieldsPopover = (
            <Popover id="popover-basic">
                <Popover.Title as="h2">Please correct the following errors:</Popover.Title>
                {required.map((item: string, index: number) =>
                    <div className="uac-missing-info-tooltip-text" key={`miss-comp-${index}`}>
                        <p className="uac-missing-info-tooltip-text-item-number">{`${index + 1}. `}</p>
                        <p className="uac-missing-info-tooltip-text-item">{item.replace(/([A-Z])/g, ' $1').trim()}</p>
                    </div>
                )}
            </Popover>
        )

        const NothingToSaveToolTip = (
            <Tooltip id="uac-tool-tip">
                Nothing to save
            </Tooltip>
        )

        const activateToolTip = (
            <Tooltip id="uac-tool-tip">
                Activate this employee.
            </Tooltip>
        )

        const deactivateToolTip = (
            <Tooltip id="uac-tool-tip">
                Deactivate this employee.
            </Tooltip>
        )

        return (
            <div className="UserAdminTopRightControls">
                {(this.props.isDirty || this.props.secureIsDirty) && !this.props.loading && required.length === 0 && <div id="user-admin-edited-save-wrapper" onClick={() => this.props.updateEmployee()}>
                    <p id="user-admin-can-save-btn" >Save</p>
                    <span className="material-icons">save</span>
                </div>}
                {(this.props.isDirty || this.props.secureIsDirty) && !this.props.loading && required.length > 0 &&
                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="left" overlay={CheckFieldsPopover}>
                        <div id="user-admin-not-edited-save-wrapper" className="WorstCodeIEverWrote">
                            <p id="user-admin-cant-save-btn">Save</p>
                            <span className="material-icons">info</span>
                        </div>
                    </OverlayTrigger>}
                {(!this.props.isDirty || !this.props.secureIsDirty) && !this.props.loading && required.length > 0 &&
                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="left" overlay={CheckFieldsPopover}>
                        <div id="user-admin-not-edited-save-wrapper" className="WorstCodeIEverWrote">
                            <p id="user-admin-cant-save-btn">Save</p>
                            <span className="material-icons">info</span>
                        </div>
                    </OverlayTrigger>}
                {(!this.props.isDirty && !this.props.secureIsDirty) && !this.props.loading && required.length === 0 &&
                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={NothingToSaveToolTip}>
                        <div id="user-admin-not-edited-save-wrapper">
                            <p id="user-admin-cant-save-btn">Save</p>
                            <span className="material-icons">info</span>
                        </div>
                    </OverlayTrigger>}
                {this.props.loading && <div id="user-admin-not-edited-save-wrapper">
                    <p id="user-admin-cant-save-btn">...</p>
                    <Spinner id="saving-employee-info-spinner" animation="border" variant="secondary" />
                </div>}
                {!this.props.employee.Inactive && !this.props.loading &&
                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="left" overlay={deactivateToolTip}>
                        <div id="employee-active-status" onClick={() => this.props.toggleActivate("deactivatePrompt")}>
                            <p>Active</p>
                            <div id="employee-active-green">

                            </div>
                        </div>
                    </OverlayTrigger>}
                {this.props.employee.Inactive && !this.props.loading &&
                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="left" overlay={activateToolTip}>
                        <div id="employee-inactive-status" onClick={() => this.props.toggleActivate("activatePrompt")}>
                            <p>Inactive</p>
                            <div id="employee-inactive-red"></div>
                        </div>
                    </OverlayTrigger>}
            </div>
        )
    }
}
export default UserAdminTopRightControls